import CzechFlagIcon from '@app/assets/flagIcons/flat/czechFlag.svg?react'
import EnglishFlagIcon from '@app/assets/flagIcons/flat/englishFlag.svg?react'
import FranceFlagIcon from '@app/assets/flagIcons/flat/franceFlag.svg?react'
import GermanFlagIcon from '@app/assets/flagIcons/flat/germanFlag.svg?react'
import SpanishFlagIcon from '@app/assets/flagIcons/flat/spanishFlag.svg?react'
import ItalyFlagRoundIcon from '@app/assets/flagIcons/round/italyFlagRound.svg?react'
import { Language } from '@app/data'

export const languageToFlagIcon: Record<Language, typeof EnglishFlagIcon> = {
  ENGLISH: EnglishFlagIcon,
  CZECH: CzechFlagIcon,
  GERMAN: GermanFlagIcon,
  SPANISH: SpanishFlagIcon,
  FRENCH: FranceFlagIcon,
  // TODO: not used yes, add when needed
  ITALIAN: ItalyFlagRoundIcon
}
